import { Typography } from '@mui/material';
import React from 'react';
import Content from '../components/Layout/Content';

export const AdvanceDirective = () => {
  return (
    <Content>
      <Typography>In the Advance Directive Page!</Typography>
    </Content>
  );
};
